/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useAppKit, useAppKitAccount, useAppKitNetwork, useAppKitProvider } from '@reown/appkit/react'
import { ethers } from 'ethers'
import { getCollectionById, backendFetch, createCollection } from "../../../lib/api";
import chainData from '../../../chains.js'
import { getDataForChain } from '../../../utils/index.js'
import { useNavigate, useLocation, Link } from "@tanstack/react-router";
import { cleanUrl, stripFile } from "../../../utils/index.js";
import { toast } from "react-toastify";
import { callWrapper } from "../../../utils/callWrapper.js"
import { QuickOptions } from "../QuickOptions.jsx";
import { Modal2 } from "../../../components/Modal/index.jsx";
import { ManageDeployer } from "./ManageDeployer.jsx";
import "./qoStyles.css"
import { newnd721 } from "../../../abi/NDNFTFactory_new.js";
import { getHeldTokens } from "../../../components/getTokens.js"
//import ViriMultiCall from "../../../abi/ViriMultiCall.js"


const handleError = (e, typeErr) => {
}

const getContractMetadata = async (address, provider, sImg) => {
    const abi = [
        'function name() view returns (string name)',
        'function symbol() view returns (string symbol)',
        'function owner() view returns (address owner)',
        'function tokenURI(uint256 tokenId) view returns(string uri)',
        'function uri(uint256 tokenId) view returns(string uri)',
        'function supportsInterface(bytes4 interfaceId) view returns (bool)',
        'function totalSupply() view returns (uint256)',
        'function tokenByIndex(uint256 id) view returns(uint256 tid)',
    ];
    const { chainId } = await provider.getNetwork();
    const cdat = getDataForChain(chainId);
    const contract = new ethers.Contract(address, abi, provider);
    let [name, symbol, owner, tokenURI, tokenByIndex, uri1155, totalSupply, isERC721, isERC1155, isERC20, collSQL] = await Promise.all([
        contract.name().catch(e => handleError(e, "name")),
        contract.symbol().catch(e => handleError(e, "symbol")),
        contract.owner().catch(e => handleError(e, "owner")), // collection owner
        contract.tokenURI(1).catch(e => handleError(e, "tokenURI 1")), // URL for ERC-721
        contract.tokenURI(contract.tokenByIndex(0)).catch(e => handleError(e, "tokenByIndex 0")),
        contract.uri(1).catch(e => handleError(e, "uri")), // URI for ERC-1155
        contract.totalSupply().catch(e => handleError(e, "totalSupply")),
        contract.supportsInterface('0x80ac58cd').catch(e => handleError(e, "supportsInterface")), // ERC-721
        contract.supportsInterface('0xd9b67a26').catch(e => handleError(e, "supportsInterface")), // ERC-1155
        contract.supportsInterface('0x36372b07').catch(e => handleError(e, "supportsInterface")),
        getCollectionById(address).catch(e => {
            console.error('Failed to fetch collection by id:', e);
            return null;
        })
    ]);
    let resp;
    //let img;

    if (!tokenURI) tokenURI = tokenByIndex;



    if (tokenURI && uri1155) {
        tokenURI = uri1155//+"/0000000000000000000000000000000000000000000000000000000000000001";
    }

    let isOnchainTraits = false;

    if (tokenURI) {
        tokenURI = tokenURI?.includes("ipfs://") ? tokenURI.replace("ipfs://", "https://ipfs.io/ipfs/") : tokenURI;

        isOnchainTraits = tokenURI.substr(0, 10).includes("data:app");


        await fetch(tokenURI)
            .then(async response => {
                //console.log(response.json())
                resp = await response.json()
            })
            // .then(data => {
            //     console.log(data);
            //     resp = data;
            // })
            .catch(async e => {
                const _res = await backendFetch(tokenURI);
                resp = _res
            })


        sImg(resp?.image?.replace("ipfs://", "https://ipfs.io/ipfs/"))
    }
    let img_ = resp?.image
    let compiler = resp?.compiler;
    // await fetch(resp.image)
    //     .then(response=>response.text())
    //     .then(data=>{ console.log(data); img = data;})
    return {
        name,
        symbol,
        owner,
        tokenURI,
        isERC721,
        isERC1155,
        isERC20,
        img_,
        totalSupply,
        collSQL,
        address,
        compiler,
        isOnchainTraits
    };
}

/**
 * Opt1 component.
 *
 * Form for adding a new NFT collection to the marketplace.
 * Allows search and selection of an existing contract to register.
 * Features:
 * - Contract address search
 * - Metadata fetching via getContractMetadata
 * - Validation that only collection owner can add
 * - Backend submission via newColl
 *
 * Part of Management page form selector.
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view (e.g., setMpItem)
 * @returns {React.ReactElement} Add collection form
 */
const Opt1 = ({clickCallback}) => {

    const [nftData, sNFTd] = useState({})
    // eslint-disable-next-line no-unused-vars
    const {wallet, open, close} =  useAppKit()
    const {isConnected, address} = useAppKitAccount();
    const { walletProvider } = useAppKitProvider("eip155");
    const [nImg, sNImg] = useState()
    //const [dispPane, sDP] = useState(true)
    const { chainId } = useAppKitNetwork();

    const navigate = useNavigate();

    const gotoColl = async (id) => {
        navigate({ to: "/collection/" + id });
    }

    const addColl = async (id, nftData) => {
        if (nftData.owner.toLowerCase() !== address.toLowerCase()) {
            toast.error("Only the collection owner or can add the collection. If this is your collection, please connect with the wallet you used to deploy it");
            //alert(nftData.owner.toLowerCase()+"\n\n"+wallet.accounts[0].address.toLowerCase())
        } else {

            if (isConnected) {
                let inf = getDataForChain(chainId);

                let turi;
                try {
                    turi = stripFile(cleanUrl(nftData?.tokenURI, false));
                } catch (e) {
                    turi = "";
                }

                const res = await createCollection({
                    collName: nftData.symbol,
                    symbol: nftData.name,
                    owner: nftData.owner,
                    supply: nftData.totalSupply.toString(10),
                    // uri: nftData.tokenURI,
                    uri: turi,
                    addr: nftData.address,
                    // img: nftData.img_,
                    img: cleanUrl(nftData.img_, false),
                    networkNumber: inf.ourId
                });


                    toast.info(<>Collection Added, Id: {res?.id[0]}<br/><br/><Link
                        to={"/collection/" + res?.id[0]}>View...</Link></>)

            }
            // insert the collection into the db, then navigate to its collection page
        }
    }

    const fetchNFTInfo = async () => {
        let addr = document.getElementById("nftAddr").value;
        if (!isConnected) {
            toast.error("Connect to a supported EVM blockchain first!");
            //return;
        } else if (!addr || (addr.hasOwnProperty("length") && addr.length !== 42)) {
            toast.error("Invalid or missing contract address!");
            //return;
        } else {
            let s123 = document.getElementById("aaa123");
            s123.style.display = "none"
            let s124 = document.getElementById("aaa124");
            s124.style.display = "flex"

            let prov = new ethers.providers.Web3Provider(walletProvider)

            let nd = await getContractMetadata(addr, prov, sNImg)
            sNFTd(nd)

        }

    }

    useEffect(() => {
    }, [nftData])

    return (

        <div className="card card-purple p-3" style={{color: "green", fontWeight: "bold"}}>
            Import Existing EVM Collection<br/><br/>
            <div id="aaa123">
                <input onBlur={() => fetchNFTInfo} id="nftAddr" className="input-purple w-100" name="collna"
                       placeholder={"Contract Address"}/><br/>
                <span className="w-100 text-light small">
                This is the address of the collection you wish to import. Whilst any user can import any collection (if
                it is not already imported), only the deployer of the contract can take ownership and edit the
                collection's information.
            </span>
                <button id="def" onClick={() => fetchNFTInfo()}
                        className="btn w-100 bg-gradient-dark my-4 mb-2">
                    Click for contract info
                </button>
            </div>
            <div id="aaa124" style={{display: "none", transition: "all .75s ease"}} className="row">
                <div className="col" style={{height: "150px", maxWidth: "150px", borderRadius: "12px"}}>
                    <img alt=""
                         style={{alignContent: "flex-start", height: "150px", width: "150px", borderRadius: "12px"}}
                         src={nImg}/></div>
                <div className="col m-2" style={{alignContent: "flex-start"}}>
                    {JSON.stringify(nftData) !== "{}" ? <div>
                        {/*{alert(JSON.stringify(nftData))}*/}
                        Name: {nftData.name} <br/>
                        Symbol: {nftData.symbol} <br/>
                        Owner: {nftData.owner ? nftData?.owner?.substring(0, 6) : "Unknown"}..{nftData?.owner ? nftData?.owner?.substring(38, 42) : ""} <br/>
                        Type: {nftData.isERC20 || (!nftData.isERC1155 && !nftData.isERC721 && nftData.symbol) ?
                        <>Not an NFT, most likely ERC-20</> :
                        <>{nftData.isERC721 ? <>ERC-721{nftData.isOnchainTraits ? ", with On-Chain Meta" : ""}</> : <>{nftData.isERC1155 ? <>ERC-1155</> : <>Unknown!</>}</>}</>}
                    </div> : null}
                    {nftData.totalSupply ? <>Supply: {nftData.totalSupply.toString()}</> : null}
                    {nftData.collSQL?.length ? <>
                            <br/>Collection Already Exists!
                            <br/>Tags: {nftData?.collSQL[0]?.tags}
                            <br/>Popularity: {nftData.collSQL[0]?.popScore}, Network:&nbsp;
                            {nftData?.collSQL[0]?.network ? chainData[nftData?.collSQL[0]?.network]?.chainName : null}
                            <br/>

                        </> :
                        null
                    }

                </div>

                <div>
                    {nftData.collSQL?.length ?
                        <button id="defu" onClick={() => gotoColl(nftData.collSQL[0].id)}
                                className="btn bg-gradient-dark w-100 mb-2 mt-1">
                            Go to collection Page
                        </button>
                        :
                        <>
                            <button id="defh" onClick={() => addColl("1", nftData)}
                                    className="btn bg-gradient-dark w-100 mb-2 mt-1">
                                Import this collection
                            </button>
                            {/*<button id="defg" onClick={() => addColl("1", nftData)}*/}
                            {/*        className="btn bg-gradient-dark mb-2 mt-1">*/}

                            {/*</button>*/}
                        </>
                    }
                </div>
            </div>

            <Button id="def" onClick={() => clickCallback("def")}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button>

        </div>

    );
}

/**
 * Opt2 component (Collection Import/Deploy selector).
 *
 * Displays options for:
 * - Import EVM Collection
 * - Import XRPL Collection
 * - Create EVM Collection
 *
 * Buttons trigger clickCallback with button IDs to navigate to specific forms.
 *
 * @param {Object} props - Component props
 * @param {string} props.text - Unused
 * @param {string} props.title - Unused
 * @param {Function} props.clickCallback - Called with (event.target.id) on button click
 * @returns {React.ReactElement} Collection options menu
 */
const Opt2 = ({text, title, clickCallback}) => {

    return (

        <div className="card p-3">
            Import existing XRPL Collection<br/>
            <Button id="opt1" onClick={(event) => clickCallback(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Import EVM Collection</Button>
            <span className="text-info text-primary">Import a pre-existing collection on an EVM blockchain. You will need to be connected to the chain on which
            the collection exists,
                and you will need to prove that you are the owner of the deployed contract.</span>
            <Button id="opt2" onClick={(event) => clickCallback(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Import XRPL Collection</Button>
            Import a pre-existing collection on XRPL. You will need to prove ownership of the deployer address.
            <Button id="opt3" onClick={(event) => clickCallback(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Create EVM Collection</Button>
            Deploy contracts for a collection on an EVM chain. Requires that you have already deployed your metadata and
            images to IPFS or
            other file hosting service.
            <Button id="opt4" onClick={(event) => clickCallback(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Import XRPL Collection</Button>
            Deploy contracts for a collection on XRPL. Requires that you have already deployed your metadata and images
            to IPFS or
            other file hosting service.
            <p className="text-bold">{text}</p>
            <h2 className="font-weight-bolder">{title}</h2>
            <Button id="def" onClick={() => clickCallback("def")}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button>
        </div>

    );
}

/**
 * Opt3 component.
 *
 * Form for managing collection royalty splits and mint reflections.
 * Allows configuration of:
 * - Royalty recipients and percentages
 * - Mint reflection percentage to holders
 *
 * Used within Management page for collection configuration.
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view
 * @param {Function} props.ssu - Signal update function to refresh parent
 * @returns {React.ReactElement} Royalty and reflection configuration form
 */
const Opt3 = ({clickCallback, ssu}) => {
    const [isRoyal, sIR] = useState()
    const [isRefl, sRFL] = useState()
    const [payees, sPay] = useState([{address: "", percentage: 100}])
    const [upd, sUpd] = useState(0)
    const [cd, scd] = useState()
    const { open, close } = useAppKit()
    const { walletProvider } = useAppKitProvider("eip155");
    const { isConnected, address } = useAppKitAccount();
    const { chainId } = useAppKitNetwork();

    const addPayee = () => {
        let ppInfo = payees;
        ppInfo.push({address: "Address", percentage: 100})
        sPay(ppInfo)
        sUpd(Math.random())
    }
 
    let cw = new callWrapper("console", {rpcUrl: chainData[1].rpc, chainId: chainData[1].chainId})

    useEffect(() => {
    }, [upd])

    useEffect(() => {
        if (isConnected) {
            let d = getDataForChain(chainId);
            scd(d)
        }
    }, [isConnected, chainId])

    const dContracts = [];
    dContracts["0x10"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd"; // 16 / SGBT
    dContracts["0x13"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd";
    dContracts["0x" + parseInt(114).toString(16)] = "0x1"

    if (!isConnected) {
        toast.error("Connect wallet first!")
    }

    const toggleRoyalty = () => {
        let elem = document.getElementById("royal");
        if (isRoyal) {
            sIR(false)
            elem.style.visibility = "hidden";
            elem.style.display = "none";
        } else {
            sIR(true)
            elem.style.visibility = "visible";
            elem.style.display = "block";
        }
    }
    const toggleReflect = () => {
        let elem = document.getElementById("refl");
        if (isRefl) {
            sRFL(false)
            elem.style.visibility = "hidden";
            elem.style.display = "none";
        } else {
            sRFL(true)
            elem.style.visibility = "visible";
            elem.style.display = "block";
        }
    }

    const deployEVM = async () => {
        if (!isConnected) {
            toast.error("Connect wallet first!")
            return;
        }

        const abi = [
            'function newERC721(string TokenName, string Symbol, address collectionOwner, string baseURI, uint256 defMintFee)',
            'function newND721((string tname,string symbol,uint256 maxsupp,uint256 rpool,uint256 secroy,string tokuri,uint256 price,uint256 flags,address owner,uint256 wldiscount,address impl,address rmimpl)) payable',
            'function defImplementation() view returns(address)',
            'function defRMImplementation() view returns(address)',
            'function usersTokensLen(address) view returns(uint256 count)',
            'function freeMintNFT(uint256, address, uint256[])',
            'function tokensByAddress(address) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl)[])',
            'function tokenByAddress(address, uint256) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl))',
        ];

        const dButton = document.getElementById("deployEVM");
        dButton.disabled = true;
        dButton.innerText = "Attempting to deploy, please wait";
        const options = {value: "0", gasLimit: 8000000}
        
        let signer = (new ethers.providers.Web3Provider(walletProvider)).getSigner()
        //const cHid = document.getElementById("_chainName")
        let cdat = chainData[cd?.ourId];

        let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);

        //toast("selected chain: "+cdat.chainName)
        const contract = new ethers.Contract(cdat.nftDeployer, abi, signer);
        const rcontract = new ethers.Contract(cdat.nftDeployer, abi, caller);
        //await contract.deployed();
        let impl = await rcontract.defImplementation();
        let rmimpl = await rcontract.defRMImplementation();

        //string tname,string symbol,uint256 maxsupp,uint256 rpool,uint256 secroy,string tokuri,uint256 price,uint256 flags,address owner,uint256 wldiscount,address impl,address rmimpl

        const argz = [
            document.getElementById("_cName").value,      // token name
            document.getElementById("_cSymb").value,   // token symbol
            document.getElementById("_tSupply").value,      // max supply/ipfs/bafybeibgm3n3zz2ajyktfkvnknni3sglpcjoi7maksplxuo5bbhyum5wv4/
            0,        // reward pool percent
            0,        // secondary royalties
            document.getElementById("_jURI").value,
            //"ipfs://bafybeibgm3n3zz2ajyktfkvnknni3sglpcjoi7maksplxuo5bbhyum5wv4/", // json uri
            document.getElementById("_itemCost").value,//"50",       // mint price (wei)
            "32",       // flags, 32 = random minting
            //"0x3a80B2A628f105c507Faf82b8824b4323eD4c0a1", //
            address,  // owner addr
            0,
            //"0xC7f436ce8CC5d516E1a212db08f6651926Ee1C14", //
            impl,
            rmimpl
        ]

        options.value = "5000";
        await cw.call(contract.newND721(argz, options), "newND721")
            .then(async (res) => {

                dButton.innerText = "Tx submitted, waiting for result";
                //let bb = await res.wait(1);
                //console.log(bb);
                let deployedct = await rcontract.usersTokensLen(address)

                let ctrInf = await rcontract.tokenByAddress(address, (deployedct - 1))

                options.value = 0;
                const contract = new ethers.Contract(ctrInf.NFTProxyAddr, abi, signer);
                await contract.freeMintNFT(1, address, [], options)
                    .then(async (res) => {
                        await res.wait(1)
                        toast.success(
                            <><b>Contract Deployed!</b><br/><br/>Address:<br/>{ctrInf.NFTProxyAddr}<br/><a
                                href={"https://coston2-explorer.flare.network/address/" + ctrInf.NFTProxyAddr}
                                target="_blank" rel="noreferrer">Explorer</a></>,
                            {autoClose: false})
                        ssu(Math.random());

                    })
                    .catch((errMsg) => {
                        toast.success(
                            <><b>Contract Deployed!</b><br/><br/>Address:<br/>{ctrInf.NFTProxyAddr}<br/><a
                                href={"https://coston2-explorer.flare.network/address/" + ctrInf.NFTProxyAddr}
                                target="_blank" rel="noreferrer">Explorer</a></>,
                            {autoClose: false}
                        )
                        toast.error("Failed whilst trying to mint 1 token: " + errMsg.message)
                        ssu(Math.random());
                    })


            })
            .catch((err) => {
                let errMsg = "Deployment failed"
                if (err.hasOwnProperty('message')) {
                    errMsg += "\n\n" + err.message;
                }
                toast.error(errMsg)
                ssu(Math.random());
            })


        //console.log({ctrInf})


        //alert(JSON.stringify(await rcontract.tokensByAddress(address)))

        // await factory.deploy(deployArgs)
        //     .then(async (res) => {
        //
        //         dButton.innerText = "Tx submitted, waiting for result";
        //         let bb = await res.wait(1);
        //         console.log(bb);
        //         console.log(res);
        //     })
        //     .catch((err) => {
        //         let errMsg="Deployment failed"
        //         if(err.hasOwnProperty('message')){
        //             errMsg+="\n\n"+err.message;
        //         }
        //         alert(errMsg)
        //         console.log(err);
        //     })


        dButton.disabled = false;
        dButton.innerText = "Deploy";
    }

    return (
        <div className="card card-purple p-3">
            Create EVM Collection<br/>
            {/*<span className="text-light small"><br/>We support multiple blockchains, please select the one that*/}
            {/*you wish to deploy on here. If you want to deploy on multiple blockchains, just go through this process again*/}
            {/*only selecting a different chain.</span>*/}
            {/*<select id="_chainName" className="input-purple" name="collna">*/}
            {/*    {chainData.map((item, id) => <>{item?.nftDeployer ? <>{item?.chainName ?*/}
            {/*        <option value={id}>{item.network}-{item.chainName} ({item.tokName})</option> : null} </> : null}</>*/}
            {/*    )}*/}
            {/*</select><br/>*/}

            <input id="_cName" className="input-purple" name="collna" placeholder={"Collection Name"}/><br/>
            <input id="_cSymb" className="input-purple" name="colls" placeholder={"Symbol"}/><br/>
            {/*<textarea id="_cInfo" className="input-purple" name={"collInf"}*/}
            {/*          placeholder={"Some information about the collection"}>*/}
            {/*</textarea>*/}
            {/*<div className="mt-2 mb-2"><label className="text-light text-decoration-underline" htmlFor="file">*/}
            {/*    Click here to choose a background image for your collection page at stealthisnft.xyz</label><input*/}
            {/*    style={{visibility: "hidden", display: "none"}} id="file" type="file"/></div>*/}

            <input id="_jURI" className="input-purple" name="juri" placeholder={"Metadata URI"}/>
            <span className="text-light small">Note that this is the location of your .json files, usually on IPFS, but
                can be self-hosted, for example.</span>
            {/*<input id="_iURI" className="input-purple" name="iuri" placeholder={"Images URI"}/>*/}
            {/*<span className="text-light small">Note that this is the location of your .png / .jpg files</span>*/}
            <input id="_itemCost" className="input-purple" name={"icost"} placeholder={"Purchase Cost"}
                   type={"number"}/>
            <span className="text-light small">Cost to mint an item</span>
            <input id="_tSupply" className="input-purple" name={"pcost"} placeholder={"Number of items"}
                   type={"number"}/>
            {/*<span className="text-light small">Total supply</span>
            <input id="_wlRed" className="input-purple" name={"_wlRed"} placeholder={"Discount for whitelist %"}
                   type={"number"}/>
            <span className="text-light small">If whitelist is enabled, give this percentage as a discount to early minters.</span>*/}
            {/*        <div>
                <input onClick={() => toggleReflect()} type="checkbox"/> Reflection enabled?
                <input style={{display: "none", visibility: "hidden"}} className="input-purple"
                       placeholder={"percentage"} id="refl" type="number"/>
            </div>
            <span className="text-light small">
                If enabled, existing holders will receive a percentage of the mint cost for every mint.
            </span>
            <div>
                <input onClick={() => toggleRoyalty()} type="checkbox"/> Royalties
                <input style={{display: "none", visibility: "hidden"}} className="input-purple"
                       placeholder={"percentage"} id="royal" type="number"/>
            </div>*/}
            <br/>
            <span className="mt-2">Instructions</span>
            <span className="text-light small">Once you click on "deploy" your contract will be deployed to the blockchain
                with a basic setup, and you will be taken to the full configuration page. From there you are able to enable
                or disable many different features and options. If you're having diffuiculty understanding anything then there
                is a guide available in our forum, or you could contact a member of our team for further assistance.
            </span>
            {/*<div className="mt-1">
                {payees.map((item, index) => <div className="mt-1">
                        <input className="input-purple" placeholder={item.address}/> &nbsp;&nbsp;
                        <input className="input-purple" placeholder={item.percentage}/>
                        {index !== (payees.length - 1) ?
                            <button onClick={() => addPayee()} className="input-purple">-</button>
                            :
                            <button onClick={() => addPayee()} className="input-purple">+</button>
                        }

                    </div>
                )}

            </div>*/}

            <Button id="deployEVM" onClick={(event) => deployEVM(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Deploy</Button>
            <Button id="def" onClick={() => clickCallback("def")}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button>

        </div>
    );
}

/**
 * Opt4 component.
 *
 * Placeholder component for additional collection management options.
 * Renders Opt3 form with different callbacks.
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view
 * @returns {React.ReactElement} Options form (Opt3)
 */
const Opt4 = ({clickCallback}) => {
    const [isRoyal, sIR] = useState()
    const [isRefl, sRFL] = useState()
    const [payees, sPay] = useState([{address: "", percentage: 100}])
    const [upd, sUpd] = useState(0)
    const addPayee = () => {
        let ppInfo = payees;
        ppInfo.push({address: "Address", percentage: 100})
        sPay(ppInfo)
        sUpd(Math.random())
    }

    useEffect(() => {
    }, [upd])

    const toggleRoyalty = () => {
        if (isRoyal) {
            sIR(false)
        } else {
            sIR(true)
        }
    }
    const toggleReflect = () => {
        if (isRefl) {
            sRFL(false)
        } else {
            sRFL(true)
        }
    }

    return (

        <div className="card card-purple p-3">
            Create XRPL Collection<br/>
            <input className="input-purple" name="collna" placeholder={"Collection Name"}/><br/>
            <textarea className="input-purple" name={"collInf"} placeholder={"Some information about the collection"}>
            </textarea>
            <div className="mt-2 mb-2"><label className="text-light text-decoration-underline" htmlFor="file">
                Click here to choose a background image for your collection page at stealthisnft.xyz</label><input
                style={{visibility: "hidden", display: "none"}} id="file" type="file"/></div>

            <input className="input-purple" name="collna" placeholder={"Metadata URI"}/>
            <span className="text-light small">Note that this is the location of your .json files, usually on IPFS, but
                can be self-hosted, for example.</span>
            <input className="input-purple" name="collna" placeholder={"Images URI"}/>
            <span className="text-light small">Note that this is the location of your .png / .jpg files</span>
            <input className="input-purple" name={"pcost"} placeholder={"Purchase Cost"} type={"number"}/>
            <span className="text-light small">Cost to mint an item</span>
            <input className="input-purple" name={"pcost"} placeholder={"Number of items"} type={"number"}/>
            <span className="text-light small">Total supply</span>
            <div><input onClick={() => toggleReflect()} type="checkbox"/> Reflection enabled?
                {isRefl ? <input className="input-purple" placeholder={"percentage"} id="refl" type="number"/> : null}
            </div>
            <span className="text-light small">
                If enabled, existing holders will receive a percentage of the mint cost for every mint.
            </span>
            <div>
                <input onClick={() => toggleRoyalty()} type="checkbox"/> Royalties
                enabled? {isRoyal ? <> Royal </> : null}
            </div>
            <span className="mt-2">Minting fee distribution</span>
            <span className="text-light small">stealthisnft.xyz charges a flat 30% on all mints, so whatever you set below is
                a percentage of the remainder. For example, if you have reflection enabled, and set to 10%, then the
                remainder will be 60% of the mint cost for each token. Using the form below, you can choose how those
                funds are distributed. Your funds will be sent out instantaneously to your wallet each and every time a
                mint is paid for. Usually the addresses you choose below would be those of the founders of the project.
            </span>
            <div className="mt-1">
                {payees.map((item, index) => <div className="mt-1">
                        <input className="input-purple" placeholder={item.address}/> &nbsp;&nbsp;
                        <input className="input-purple" placeholder={item.percentage}/>
                        {index !== (payees.length - 1) ?
                            <button onClick={() => addPayee()} className="input-purple">-</button>
                            :
                            <button onClick={() => addPayee()} className="input-purple">+</button>
                        }

                    </div>
                )}

            </div>

            <Button id="def" onClick={(event) => clickCallback(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Deploy</Button>
            <Button id="def" onClick={() => clickCallback("def")}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button>

        </div>

    );
}

/**
 * DeployERC20 component.
 *
 * Form for deploying an ERC-20 token contract.
 * Includes royalty and reflection configuration similar to Opt3.
 * Collects token details and deploys via factory.
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view
 * @param {Function} props.ssu - Signal update function
 * @param {Object} props.cInfo - Collection data
 * @returns {React.ReactElement} ERC-20 deployment form
 */
const DeployERC20 = ({clickCallback, ssu, cInfo}) => {
    const [isRoyal, sIR] = useState()
    const [isRefl, sRFL] = useState()
    const [payees, sPay] = useState([{address: "", percentage: 100}])
    const [upd, sUpd] = useState(0)
    const [cd, scd] = useState()
    const { open, close } = useAppKit()
    const { walletProvider } = useAppKitProvider("eip155");
    const { isConnected, address } = useAppKitAccount();
    const { chainId } = useAppKitNetwork();
    const addPayee = () => {
        let ppInfo = payees;
        ppInfo.push({address: "Address", percentage: 100})
        sPay(ppInfo)
        sUpd(Math.random())
    }

    let cw = new callWrapper("console", {rpcUrl: chainData[7].rpc, chainId: chainData[7].chainId})

    useEffect(() => {
    }, [upd])

    useEffect(() => {
        if (isConnected) {
            let d = getDataForChain(chainId);
            scd(d)
        }
    }, [isConnected, chainId])

    if (!isConnected) {
        toast.error("Connect wallet first!")
    }

    const toggleRoyalty = () => {
        let elem = document.getElementById("royal");
        if (isRoyal) {
            sIR(false)
            elem.style.visibility = "hidden";
            elem.style.display = "none";
        } else {
            sIR(true)
            elem.style.visibility = "visible";
            elem.style.display = "block";
        }
    }
    const toggleReflect = () => {
        let elem = document.getElementById("refl");
        if (isRefl) {
            sRFL(false)
            elem.style.visibility = "hidden";
            elem.style.display = "none";
        } else {
            sRFL(true)
            elem.style.visibility = "visible";
            elem.style.display = "block";
        }
    }

    const deployERC20 = async () => {
        if (!isConnected) {
            toast.error("Connect wallet first!")
            return;
        }

        const abi = ERC20Factory.abi;

        const dButton = document.getElementById("deployERC20");
        dButton.disabled = true;
        dButton.innerText = "Attempting to deploy, please wait";
        const options = {value: "0", gasLimit: 8000000}
        
        let signer = (new ethers.providers.Web3Provider(walletProvider)).getSigner()
        //const cHid = document.getElementById("_chainName")
        let cdat = chainData[cd?.ourId];

        let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);

        //toast("selected chain: "+cdat.chainName)
        const contract = new ethers.Contract(cdat.erc20Factory, abi, signer);
        const rcontract = new ethers.Contract(cdat.erc20Factory, abi, caller);
        //await contract.deployed();
        let impl = await rcontract.defImpCtr();
        //let rmimpl = await rcontract.defRMImplementation();
        //console.log(impl, rmimpl);

        //string tname,string symbol,uint256 maxsupp,uint256 rpool,uint256 secroy,string tokuri,uint256 price,uint256 flags,address owner,uint256 wldiscount,address impl,address rmimpl

        const argz = [
            document.getElementById("_cName").value,      // token name
            document.getElementById("_cSymb").value,   // token symbol
            document.getElementById("_initSupply").value,      // max supply/ipfs/bafybeibgm3n3zz2ajyktfkvnknni3sglpcjoi7maksplxuo5bbhyum5wv4/
            address,  // owner addr
        ]

        options.value = "50000";

        //await contract.callStatic.newERC20(...argz)
        //     .then(async a => {
                await contract.newERC20(...argz, options)

                    .then(async (res) => {

                        dButton.innerText = "Tx submitted, waiting for result";
                        //let bb = await res.wait(1);
                        //console.log(bb);
                        await res.wait(1);
                        let deployedct = await rcontract.usersTokensLen(address)
                        let ctrInf = await rcontract.userTokens(address, (deployedct - 1))
                        options.value = 0;
                        const contract = new ethers.Contract(ctrInf.NFTProxyAddr, abi, signer);

                        toast.success(
                            <><b>Contract Deployed!</b><br/><br/>Address:<br/>{ctrInf.NFTProxyAddr}<br/><a
                                href={"https://coston2-explorer.flare.network/address/" + ctrInf.NFTProxyAddr}
                                target="_blank" rel="noreferrer">Explorer</a></>,
                            {autoClose: false})

                        ssu(Math.random());


                    })
           // })
            // .catch((err) => {
            //     let errMsg = +err?.reason
            //     // if (err.hasOwnProperty('message')) {
            //     //     errMsg += "\n\n" + err.message;
            //     // }
            //     toast.error(<><b>Deployment Failed</b><br/>Reason: {err?.reason}</>)
            //     ssu(Math.random());
            //     console.log(errMsg);
            //     //console.log(err.stack)
            // })


        //console.log({ctrInf})


        //alert(JSON.stringify(await rcontract.tokensByAddress(address)))

        // await factory.deploy(deployArgs)
        //     .then(async (res) => {
        //
        //         dButton.innerText = "Tx submitted, waiting for result";
        //         let bb = await res.wait(1);
        //         console.log(bb);
        //         console.log(res);
        //     })
        //     .catch((err) => {
        //         let errMsg="Deployment failed"
        //         if(err.hasOwnProperty('message')){
        //             errMsg+="\n\n"+err.message;
        //         }
        //         alert(errMsg)
        //         console.log(err);
        //     })


        dButton.disabled = false;
        dButton.innerText = "Deploy";
    }

    return (
        <div className="card card-purple p-3">
            Create ERC20 Token<br/>
            <br/>
            <input id="_cName" className="input-purple" name="collna" placeholder={"Token Name"}/><br/>
            <input id="_cSymb" className="input-purple" name="colls" placeholder={"Token Symbol"}/><br/>

            {/*<input id="_iURI" className="input-purple" name="iuri" placeholder={"Images URI"}/>*/}
            {/*<span className="text-light small">Note that this is the location of your .png / .jpg files</span>*/}
            {/*<input id="_itemCost" className="input-purple" name={"icost"} placeholder={"Purchase Cost"}*/}
            {/*       type={"number"}/>*/}

            {/*<span className="text-light small">Initial supply</span>*/}

            <input id="_initSupply" className="input-purple" name={"_initSupply"}
                   placeholder={"Initial supply of (whole) tokens"}
                   type={"number"}/>
            {/*<span className="text-light small">If whitelist is enabled, give this percentage as a discount to early minters.</span>*/}

            <br/>
            <span className="mt-2">Instructions</span>
            <span className="text-light small">Once you click on "deploy" your contract will be deployed to the blockchain
                with a basic setup, and you will be taken to the full configuration page. From there you are able to mint, burn, and
                add/remove contracts or wallets with administrative access to the protected contract functions
            </span>


            <Button id="deployERC20" onClick={(event) => deployERC20(event.target.id)}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Deploy</Button>
            <Button id="def" onClick={() => clickCallback("def")}
                    className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button>

        </div>
    );
}

/**
 * ManageEVM component.
 *
 * Management interface for an EVM-based NFT collection.
 * Displays collection info and provides QuickOptions dropdown.
 * Shows:
 * - Collection metadata (name, symbol, supply)
 * - Quick options (free mint, presale, whitelist, etc.)
 * - Token image if available
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view
 * @param {Object} props.cInfo - Collection data from database
 * @returns {React.ReactElement} EVM collection management panel
 */
const ManageEVM = ({clickCallback, cInfo}) => {
    //  const [isRoyal, sIR] = useState()
    // const [isRefl, sRFL] = useState()
    const {address, isConnected} = useAppKitAccount();
    const {walletProvider} = useAppKitProvider("eip155");
    const {chainId, switchChain} = useAppKitNetwork();

    const [payees, sPay] = useState([{id: 0, address: address, percentage: 100}])
    const [showModal, ssm] = useState(false);
    const [modalContent, smc] = useState();
    const [modalTitle, smt] = useState()
    // eslint-disable-next-line no-unused-vars
    const [whitelist, swl] = useState([])
    const [cDat, scDat] = useState([])

    let item = cInfo;



    const addPayee = () => {
        sPay(prev => [...prev, {id: prev.length, address: "Address", percentage: 100}])
    }

    const delPayee = (id) => {
        sPay(prev => {
            let tmp = [];
            let ct = 0;
            for (let i = 0; i < prev.length; i++) {
                if (prev[i].id !== id) {
                    tmp.push({id: ct, address: prev[i].address, percentage: prev[i].percentage})
                    ct++;
                }
            }
            return tmp;
        })
    }

    // let sup;
    // let hdb = [
    //     ""
    // ]

    function helpToast(e) {
        let help = {
            wl: <><b>Whitelist discount %</b><br/>
                <div className="small helptoast">An optional discount that you can specify for buyers minting your
                    tokens
                    who you have added to the Whitelist. It is only applicable whilst your contract is in "Presale"
                    mode.
                </div>
            </>,
            mp: <><b>Mint Price </b><br/>
                <div className="small helptoast">The price you are charging per token. This can be adjusted at any time.
                    Note that this is expressed in native tokens, and not "wei", so if you're charging 100 SGB, for
                    example, just enter 100.
                </div>
            </>,
            js: <><b>JSON Metadata URI </b><br/>
                <div className="small helptoast">The location for the metadata for your collection, this usually begins
                    with ipfs:// or
                    https://<br/><b>IMPORTANT:</b> This is the address for your .json files, not your .png/.jpg files.
                </div>
            </>,
            de: <><b>Description </b><br/>
                <div className="small helptoast">A description of your collection and what its about / its features.
                    This will appear
                    on your collection's page when you list it on the marketplace.
                </div>
            </>,
            rp: <><b>Royalty %</b><br/>
                <div className="small helptoast">Royalties allow you to take a cut of resales of your items, if the
                    marketplace you are selling on
                    supports them. Not all marketplaces are created equal, so whilst we support EIP-2981 royalties,
                    others like Sparkles do not, and
                    you would have to set up royalties manually through their interface. To be fair, we have limited the
                    max royalty to 20%. To disable
                    royalties, simply leave this empty or 0.
                </div>
            </>,
            re: <><b>Reflection %</b><br/>
                <div className="small helptoast">Enabling reflection means that this percentage of earnings from mints
                    will be distributed amongst
                    the holders of your tokens. Additionally, enabling reflection means that any royalties recieved for
                    secondary sales are also shared
                    between the hodlers.
                </div>
            </>,
            mf: <><b>Mint Fee Distribution:</b><br/>
                <div className="small helptoast">stealthisnft.xyz charges a flat fee on all mints, so whatever you set below
                    is a percentage of the
                    remainder. Using the form below, you can choose how those funds are distributed. Your earnings will
                    be available to claim
                    each and every time a mint is paid for. Usually the addresses you choose below would be those of the
                    founders
                    of the project.
                </div>
            </>,

        }


        toast.info(help[e.target.id], {autoClose: 15000});
    }

    useEffect(() => {
        async function checkSwitch() {
            // await getInfo();  <-- REMOVED
            try {
                let cDat = item;
                if (item?.network && chainId && switchChain && (chainId?.toString(10) !== parseInt(chainData[item?.network]?.chainId).toString(10))) {
                    toast("switch to " + chainData[cDat?.network]?.tokName)
                    switchChain({chainId: "0x" + parseInt(chainData[cDat?.network].chainId).toString(16)})
                        .catch((e) => {
                        })
                } else {
                    getInfo();
                }
            } catch (e) {
            }


            // getInfo()
        }

        checkSwitch()
    }, [item, chainId, switchChain])

    let reflection = true;

    // const dContracts = [];
    // dContracts["0x10"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd"; // 16 / SGBT
    // dContracts["0x13"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd";
    // dContracts["0x" + parseInt(114).toString(16)] = "0x1"


    //const abi = _NDNFT;
    const abi = newnd721;

    if (!isConnected) {
        toast.error("Connect wallet first!")
    }

    const getInfo = async () => {
        //console.log("cd", cDat)
        if (!isConnected) {
            toast.error("Connect wallet first!")
            return;
        }

        let cdat = getDataForChain(chainId.toString(16)).data;
        let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);




        const rcontract = new ethers.Contract(cInfo?.NFTProxyAddr ? cInfo.NFTProxyAddr : cInfo?.contractAddress, newnd721, caller);
        //await contract.deployed();
        //let impl = await rcontract.defImplementation();
        //let rmimpl = await rcontract.defRMImplementation();
        let cfg = [];
        let fallbackABI = [
            'function cfg() view returns(tuple(uint256 MAX_SUPPLY, uint256 RewardsPoolPercent, uint256 secSalesRoyalty, uint256 _MINT_PRICE, uint256 WLDiscount, address RMAddress, address Staking, address Wnat, address FTSORM, address NFTDelegator, address BonusToken, bool isDisabled, address extPriceAddress))',
           // 'function cfg() view returns(tuple(uint256 MAX_SUPPLY, uint256 RewardsPoolPercent, uint256 secSalesRoyalty, uint256 _MINT_PRICE, uint256 WLDiscount, address RMAddress, address Staking, address Wnat, address FTSORM, address NFTDelegator))',
            //'function cfg() view returns(tuple(uint256 MAX_SUPPLY,uint256 RewardsPoolPercent,uint256 secondarySalesRoyaltyPercent,uint256 _MINT_PRICE,uint256 WLDiscount,address RMAddress,address StakingContractAddress,address WNat,'
          //  +'address FTSORM,address NFTDelegatorAddress,address BonusTokenAddress,uint256 Flags,bool IsDisabled,address externalPriceAddress))',

        'function str() view returns(tuple(string TokenURI, string ContractState, string epFunction, string btFunction))',
            'function _baseTokenURI() view returns(string)',
            'function MAX_SUPPLY() view returns(uint256)',
            'function totalSupply() view returns(uint256)',
            'function MaxSupply() view returns(uint256)',
            'function supply_11() view returns(uint256)',

        ]

        await rcontract.cfg()
            .then(r => {
                cfg = r;
            })
            .catch(async e => {
                const rcontract = new ethers.Contract(cInfo?.NFTProxyAddr ?? cInfo?.contractAddress, fallbackABI, caller);
                await rcontract.cfg()
                    .then(r => {
                        str = r;
                    })
                    .catch(async e => {

                        await Promise.all([
                            rcontract.MAX_SUPPLY()
                            ]
                        ).then(vals => {
                        }).catch(e => {
                        toast("cant get contract config :(" + (cInfo?.NFTProxyAddr ?? cInfo?.contractAddress))
                        })
                    })
            });
        let str;
        await rcontract.str()
            .then(r => {
                str = r;
            })
            .catch(async e => {
                const rcontract = new ethers.Contract(cInfo?.NFTProxyAddr ?? cInfo?.contractAddress, fallbackABI, caller);
                await rcontract.str()
                    .then(r => {
                        str = r;
                    })
                    .catch(async e => {
                       // const altmethod = new ethers.Contract(cInfo?.NFTProxyAddr ?? cInfo?.contractAddress, fallbackABI, caller);
                        str={}
                        await rcontract?._baseTokenURI()
                            .then(r => {
                                str['TokenURI'] = r;
                            })
                            .catch(e => {

                                toast("cant get contract strings :(")
                            });
                        await rcontract?.MAX_SUPPLY()
                        .then(r => {
                            cfg['MAX_SUPPLY'] = r;

                        })
                        .catch(e => {
                            toast("cant get max supply")
                        })
                    })

            });


        document.getElementById("_jURI").value = str.TokenURI;
        //document.getElementById("_itemCost").value = cfg._MINT_PRICE;
        //document.getElementById("_tSupply").value=cfg.MAX_SUPPLY;
        // document.getElementById("_wlRed").value = cfg.WLDiscount;
        if(cfg?.MAX_SUPPLY) {
            document.getElementById("sup").innerText = await rcontract.totalSupply() + " of " + cfg.MAX_SUPPLY;
        }
        try {
            let bob = await rcontract.diLen();
            let cPayees = [];
            for (let i = 0; i < parseInt(bob.toString()); i++) {
                let bob2 = await rcontract.divInfo_(i);
                cPayees.push({id: i, address: bob2.wallet, percentage: bob2.percentage.toString()});
            }
            if (cPayees.length === 0) {
                cPayees.push({id: 0, address: address, percentage: "100"})
            }
            sPay(cPayees)

        } catch (e) {

        }


    }

    window.tt = getHeldTokens;

    async function inputAnim(id, off) {
        let elem = document.getElementById(id)
        if (off) {
            elem.style.border = "2px ridge rgba(128,0,128,0.9)";
        } else {
            elem.style.border = "4px solid red";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid white";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid red";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid white";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid red";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid white";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid red";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid white";
            await new Promise(r => setTimeout(r, 100));
            elem.style.border = "4px solid red";
        }
    }

    async function doDistribution() {
        let pctTot = 0;
        let bad = false;
        for (let i = 0; i < payees.length; i++) {
            if (payees[i].address.length < 42) {
                toast.error("Bad address for payee " + (i + 1).toString())
                inputAnim("payee_addr_" + i.toString(), false)
                bad = true;
            } else {
                inputAnim("payee_addr_" + i.toString(), true)
            }
            if (payees[i].percentage < 1 || payees[i].percentage > 100) {
                toast.error("Payee percentage must be between 1 and 100")
                inputAnim("payee_pct_" + i.toString(), false)
                bad = true;
                pctTot += parseInt(payees[i].percentage);
            } else {
                inputAnim("payee_pct_" + i.toString(), true)
                pctTot += parseInt(payees[i].percentage);
            }
        }
        if (pctTot !== 100) {
            toast.error("Sum of percentages must equal 100");
            bad = true;
        }
        for (let i = 0; i < payees.length; i++) {
            if (pctTot !== 100) {
                inputAnim("payee_pct_" + i.toString(), false);
            } else {
                inputAnim("payee_pct_" + i.toString(), true);
            }
        }

        if (bad === false) {
            let cdata = []
            for (let i = 0; i < payees.length; i++) {
                cdata.push([payees[i].address, payees[i].percentage, 0]);
            }

            let cdat = getDataForChain(chainId).data;
            let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);
            let signer = (new ethers.providers.Web3Provider(walletProvider)).getSigner()
            const contract = new ethers.Contract(cInfo.NFTProxyAddr, abi, caller);
            const wcontract = new ethers.Contract(cInfo.NFTProxyAddr, newnd721, signer);

            const options = {value: "0", gasLimit: 8000000}
            let tx = await wcontract.setMintFeeRecips(cdata, options);
            await tx.wait(1);
            let bob = await contract.diLen();
            let cPayees = [];
            for (let i = 0; i < parseInt(bob.toString()); i++) {
                let bob2 = await contract.divInfo_(i);
                cPayees.push({id: i, address: bob2.wallet, percentage: bob2.percentage.toString()});
            }


        }


    }

    function payeePctChange(index, value) {
        sPay(prev => {
            const newPayees = [...prev];
            newPayees[index] = { ...newPayees[index], percentage: value };
            return newPayees;
        });
    }

    function payeeAddrChange(index, value) {
        sPay(prev => {
            const newPayees = [...prev];
            newPayees[index] = { ...newPayees[index], address: value };
            return newPayees;
        });
    }

    return (
        <div className="card card-purple p-1">
            <Modal2 show={showModal} modalTitle={modalTitle} content={modalContent}/>
            <span className="text-light input-title">Managing:</span>

            <div id="_cName" style={{
                style: "flex",
                flexDirection: "column",
                position: "relative",
                width: "100%",
                fontSize: "20px",
                textAlign: "center"
            }} className="w-100 raisedBoxPurple text-green">
                <div>{cInfo?.tokenName ? cInfo?.tokenName : cInfo?.name}
                    ({cInfo?.tokenSymbol ? cInfo?.tokenSymbol : cInfo?.symbol})</div>
                <div className="text-sm small helptoast text-green">Mints: <span
                    id="sup"></span>{/*, Total earnings: 145333 SGB, Unclaimed: 5473.26 SGB*/}</div>
            </div>
            <div style={{display: "flex", flexDirection: "column", width: "100%"}} className="raisedBoxPurple text-green">
                <div
                    style={{border: "0px inset green", display: "flex", flexDirection: "column", position: "relative"}}>
                    <div style={{flex: 1, alignSelf: "center", fontSize: "20px"}}>General Setup</div>
                    <div className="optsDropdown">
                        <QuickOptions smc={smc} swl={swl} smt={smt} ssm={ssm} item={item}/>
                    </div>
                </div>
                <span className="text-light input-title">Description:</span>
                <div style={{maxWidth: "100%", display: "flex", flexGrow: 1}}>
            <textarea id="_cInfo" style={{flexGrow: 1}} className="input-purple mb-2" name={"collInf"}
                      placeholder={"Collection description"}>
            </textarea>
                    <button id="de" onClick={(e) => helpToast(e)} style={{height: "40px", width: "32px"}}
                            className="help-purple">?
                    </button>
                </div>

                <span className="text-light input-title">JSON Metadata URI:</span>
                <div style={{maxWidth: "100%", display: "flex"}} className="mb-2">
                    <input id="_jURI" style={{flexGrow: 1, minWidth: "30%"}} className="input-purple" name="juri"
                           placeholder={"Metadata URI"}/>
                    <button id="js" onClick={(e) => helpToast(e)} style={{width: "32px"}} className="help-purple">?
                    </button>
                </div>

                <div className="mb-2"
                     style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                    <div className="nftFormNumInput nni-l" style={{
                        marginTop: "6px",
                        flexGrow: 1,
                        minHeight: "40px"
                    }}>
                    <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                          className="text-light input-title">Mint Cost:</span>
                        <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                            <input id="_itemCost" style={{width: "100%"}}
                                   className="input-purple" name={"icost"} placeholder={"Purchase Cost"}
                                   type={"number"}/>
                            <button id="mp" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                                    className="help-purple">?
                            </button>
                        </div>
                    </div>
                    <div className="nftFormNumInput nni-r" style={{
                        marginTop: "6px",
                        flexGrow: 1,
                        minHeight: "40px"
                    }}>
                    <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                          className="text-light input-title">Royalties:</span>
                        <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                            <input id="_itemCost" style={{width: "100%"}}
                                   className="input-purple" name={"icost"} placeholder={"Royalty %"} type={"number"}/>
                            <button id="rp" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                                    className="help-purple">?
                            </button>
                        </div>
                        {/*<span style={{display: "block", position: "absolute", marginTop: "-8px"}}*/}
                        {/*      className="text-light input-title">Whitelist discount %:</span>*/}
                        {/*<div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>*/}
                        {/*    <input id="_wlRed" style={{ width: "100%"}}*/}
                        {/*           className="input-purple" name={"icost"} placeholder={"WL Discount %"} type={"number"}/>*/}
                        {/*    <button id="wl" onClick={(e)=>helpToast(e)} style={{width: "32px"}} className="help-purple">?</button>*/}
                        {/*</div>*/}
                    </div>


                </div>
                {/*<div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                <div className="nftFormNumInput nni-l" style={{
                    marginTop: "6px",
                    flexGrow: 1,
                    minHeight: "40px"
                }}>
                    <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                          className="text-light input-title">Royalties:</span>
                    <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                        <input id="_itemCost" style={{width: "100%"}}
                               className="input-purple" name={"icost"} placeholder={"Royalty %"} type={"number"}/>
                        <button id="rp" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                                className="help-purple">?
                        </button>
                    </div>
                </div>
                <div className="nftFormNumInput nni-r" style={{
                    marginTop: "6px",
                    flexGrow: 1,
                    minHeight: "40px"
                }}>
                  { reflection ? <><span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                          className="text-light input-title">Reflection %:</span>
                    <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                        <input id="_wlRed" style={{width: "100%"}}
                               className="input-purple" name={"icost"} placeholder={"Reflection %"} type={"number"}/>
                        <button id="re" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                                className="help-purple">?
                        </button>
                    </div> </>: null}
                </div>


            </div>*/}
                <button className="btn btn-outline-danger text-white w-100 mt-2 mb-0">Update Settings</button>
            </div>

            <div className="raisedBoxPurple flex-row flex-wrap mt-2 text-green">
                <span style={{fontSize: "20px"}}>Minting fee distribution (Important!!)</span>
                <button id="mf" onClick={(e) => helpToast(e)} style={{width: "32px", float: "right"}}
                        className="help-purple">?
                </button>


                <div className="mt-1">
                    {payees.map((item, index) => <div className="mt-1">
                            <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                                <div className="nftFormNumInput nni-l" style={{
                                    marginTop: "6px",
                                    flexGrow: 1,
                                    minHeight: "40px"
                                }}>
                    <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                          className="text-light input-title">Wallet Address:</span>
                                    <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                                        <input id={"payee_addr_" + index}
                                               style={{width: "100%"}}
                                               className="input-purple"
                                               name={"icost"}
                                               placeholder={"Address"}
                                               value={item.address}
                                               onChange={(e) => payeeAddrChange(index, e.target.value)}
                                        />

                                    </div>
                                </div>
                                <div className="nftFormNumInput nni-r" style={{
                                    marginTop: "6px",
                                    flexGrow: 1,
                                    minHeight: "40px"
                                }}>
                        <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                              className="text-light input-title">Percentage %:</span>
                                    <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                                        <input id={"payee_pct_" + index}
                                               style={{width: "100%"}}
                                               className="input-purple"
                                               name={"icost"}
                                               placeholder={"Percentage"}
                                               type={"number"}
                                               value={item.percentage}
                                               onChange={(e) => payeePctChange(index, e.target.value)}
                                        />
                                        {index !== (payees.length - 1) ?
                                            <button onClick={() => delPayee(parseInt(item.id) + 1)}
                                                    className="help-purple">-</button>
                                            :
                                            <button onClick={() => addPayee()} className="help-purple">+</button>
                                        }
                                    </div>
                                </div>


                            </div>
                            {/*<input className="input-purple" placeholder={item.address}/> &nbsp;&nbsp;*/}
                            {/*<input className="input-purple" placeholder={item.percentage}/>*/}
                            {/*{index !== (payees.length - 1) ?*/}
                            {/*    <button onClick={() => addPayee()} className="input-purple">-</button>*/}
                            {/*    :*/}
                            {/*    <button onClick={() => addPayee()} className="input-purple">+</button>*/}
                            {/*}*/}

                        </div>
                    )}

                    <button onClick={() => doDistribution()}
                            className="btn btn-outline-danger text-white w-100 mt-2 mb-0">Update Fee Distributions
                    </button>
                </div>
            </div>
            <div className="px-2">
                <div className="mt-2 mb-2 "><label className="text-light text-decoration-underline" htmlFor="file">
                    Click here to choose a background image for your collection page at stealthisnft.xyz</label><input
                    style={{visibility: "hidden", display: "none"}} id="file" type="file"/></div>
                {/*<Button id="deployEVM" onClick={(event) => deployEVM(event.target.id)}*/}
                {/*        className="btn bg-gradient-dark w-100 my-4 mb-2">Deploy</Button>*/}
                <Button id="def" onClick={() => clickCallback("def")}
                        className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button></div>

        </div>
    );
}

/*** ManageDeployer: Set parameters for deployer an
 ***
 ***
 */



export {Opt1, Opt2, Opt3, Opt4, DeployERC20, ManageEVM, ManageDeployer}